import React from 'react';
import { Button } from 'primereact/button';

export const CopyControl = ({ className, content, style  }) => {
    return (
        <Button
            icon="pi pi-copy"
            className={className}
            rounded
            onClick={() => navigator.clipboard.writeText(content)}
            style={style} />
    )
}

